'use client';

import { Calendar, Globe } from 'lucide-react';
import { useState } from 'react';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { _zones } from '@/data';
import { TIME_RANGE, type ZONE } from '@/enums';
import { cn } from '@/libs';
export const Footer = () => {
  const [selectedZone, setSelectedZone] = useState<ZONE | 'ALL'>('ALL');
  const [timeRange, setTimeRange] = useState<TIME_RANGE>(TIME_RANGE.LAST_24_HOURS);
  return <footer className='-translate-x-1/2 fixed bottom-0 left-1/2 w-full max-w-6xl p-4'>
      <div className='rounded-lg border border-foreground/10 bg-foreground/7 p-2 backdrop-blur 2xl:p-3'>
        <div className='flex items-center justify-between'>
          <div className='flex items-center gap-4'>
            <div className='flex items-center gap-2'>
              <Globe className='ml-1 size-4 text-gray-500 dark:text-gray-400' />
              <span className='font-medium text-gray-900 text-sm dark:text-white'>
                Zones:
              </span>
            </div>
            <div className='flex gap-2'>
              <button className={cn('anim-config rounded px-3 py-1 font-medium text-sm', selectedZone === 'ALL' ? 'bg-primary/10 text-primary' : 'bg-foreground/10 text-foreground/60 hover:bg-foreground/20 hover:text-foreground/100')} onClick={() => setSelectedZone('ALL')}>
                All Zones
              </button>
              {_zones.map(zone => <button className={`anim-config rounded px-3 py-1 font-medium text-sm ${selectedZone === zone.id ? 'bg-primary/10 text-primary' : 'bg-foreground/10 text-foreground/60 hover:bg-foreground/20 hover:text-foreground/100'}`} key={zone.id} onClick={() => setSelectedZone(zone.id)}>
                  {zone.name}
                </button>)}
            </div>
          </div>

          <div className='flex items-center gap-4'>
            <div className='flex items-center gap-2'>
              <Calendar className='size-4 text-foreground/60' />
              <Select onValueChange={value => setTimeRange(value as TIME_RANGE)} value={timeRange}>
                <SelectTrigger className='anim-config rounded border bg-foreground/10 text-foreground/60 text-sm hover:bg-foreground/20 hover:text-foreground/100'>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className='bg-foreground/10 backdrop-blur'>
                  <SelectGroup>
                    <SelectItem value={TIME_RANGE.LAST_24_HOURS}>
                      Last 24 hours
                    </SelectItem>
                    <SelectItem value={TIME_RANGE.LAST_7_DAYS}>
                      Last 7 days
                    </SelectItem>
                    <SelectItem value={TIME_RANGE.LAST_30_DAYS}>
                      Last 30 days
                    </SelectItem>
                    <SelectItem value={TIME_RANGE.LAST_90_DAYS}>
                      Last 90 days
                    </SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};